var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect, _rect2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path21, _path22, _polygon7, _path23, _path24, _path25, _path26, _rect3, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUntitled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3840 2160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-2 {\n        fill: #969696;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Flooring",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flooring",
    className: "cls-2",
    style: {
      opacity: 0
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.97,2158.21c2.04-.77,8.07-4.6,14.54-8.77,74.04,3.06,159.11,3.86,224.85,4.26,58.7.35,127.7,5.77,184.51.68,1.36-.85,4.85-2.98,8.17-6.13.35-7.85.03-22.87.68-30.64,269.54-189.1,539.47-387.41,809.71-574.94,14.11-.55,29.31-1.12,42.85-4.1,3.59,27.09,9.75,75.61,42,81.94l-10.04,8.92c-19.2,95.99-35.68,194.7-49.59,292.11-1.68,11.75-9.01,41.46-2.38,49.68.92,1.14,6.31,4.93,7.04,4.93h119.94c.21,0,3,2.79,3,3v34.97h49.97c1.34-9.48,10.85-19.46,13.06-27.9,6.63-25.28,1.72-42.15.85-66.93-.38-10.98.45-22.09.07-33.06,11.29-1.85,36.77,5.79,45.54-2.44,1.98-1.86,2.05-7.54,2.44-7.54h53.97l-24.06,202.91c1.48,17.16,9.01,5.87,13.03-3.13,11.74-26.27,31.55-85.07,34.99-112.89,2.75-22.29,2.2-46.57,4.89-69.04,1.43-2.05,3.88-1.71,6.03-1.97,33.62-4.08,100.67-1.83,136.11.01,8.7.45,17.64,3.65,26.91,2.07l14.09,186.73c1.89,8.86,8.65,15.87,11.77,3.99,7.5-28.59,5.17-68.07,11.71-97.79l-11.59-106.9h219.89l-12.07,108.81c6.44,30.29,1.69,68.43,8.14,97.92,1.37,6.27,7.46,8.95,9.92,3.58,3.63-7.94,2.94-40.06,4.01-51.44,4.51-47.62,10.28-95.2,13.97-142.89,57.3.59,114.78-1.58,171.93,2l8.49,92.42,33.3,104.22c7.11,4.92,8.04-3.67,8.26-9.71l-22.07-200.91h57.97c.65,0,.65,9.99,7,9.99h40.98l-7.86,74.62c1.1,17.4,10.92,14.1,14.03,18.57,2.3,3.3,1.25,10.45,2.78,14.75,1.09,3.06,10.72,21.94,12.03,21.94h50.97v-35.97h116.94c.44,0,6.93-4.97,7.04-5.4,3.71-14.92-7.61-73.98-10.37-93.18-10.9-75.9-21.63-165.71-38.2-239.56-1.04-4.62-1.81-9.43-4.51-13.47-2.67-4.01-12.91-7.3-7.63-10.05,9.56-4.98,16.66-4.68,23.1-16.58,5.44-10.07,19.56-56.04,17.54-66.31-3.61-18.33-44.55-10.03-54.64-13.31-4.19-1.36-3.38-5.98-3.28-9.71h44.98c2.6,0,27.96,24.95,34.87,27.09,9.7,3,23.17-1.59,32.02,1.96,21.38,22.05,64.76,42.47,84.15,63.75,7.68,8.43,2.45,16.63,21.79,16.19l132.1,99.74c17.67-1.99,16.13,5.16,23.99,10,3.93,2.41,13.88,3.19,16.89-.95,2.22-3.06,1.28-16,5.99-13.95,49.38,36.18,100.21,70.3,149.99,105.92,2,1.43,4.37,1.65,6.64,2.25,1.6,23.88-7.35,55.55,28.38,48.74l7.91-23.05v32.97l275.82,201.85c7.39,13.57-7.15,36.88,11.94,42.02l414.96,4.81c10.18,1.09,25.03,16.09,32.89,18.08v2H49.97v-1.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3840,2158v2h-11.99v-2c3.15.8,8.42-.55,11.99,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1326.31,1970.18c-7.68-1.59-8.11-10.27-6.73-16.73l50.14-315.54c-.67-12.42,31.27-10.44,31.59-8.26l-23.6,247.19c.51,1.76,2.9,4.62,4.45,5.54,8.04,4.79,48.63,1.28,61.09,3.87v83.92h-116.94Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2511.69,1894.25c6.47-1.39,10.3-10.67,9.05-16.89l-26.05-240.87c8.4,1.7,25.01-4.58,28,4.99l53.47,333.27c-1.02,10.67-19.26,5.36-26.41,5.32-31-.16-62.05.31-93.03.1v-85.92c15.73-2.31,40.47,3.12,54.97,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1443.25,1628.49v251.77h-48.97c-8.77,0-13.12-6.47-11.09-15.05l24.08-231.72c-.09-1.64,1.88-4.99,3-4.99h32.98Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2486.7,1634.49l27.89,247.07c.95,2.12-1.38,6.7-2.9,6.7h-54.97v-253.77h29.98Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1601.17,2042.11l19.14-165.97,12.85.11c-2.42,37.91-.87,79.43-11.01,115.9-4.73,17.02-12.12,33.74-18.99,49.96h-2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2284.81,2030.12l2,4c.14,1.3-.17,2.7,0,4h-4c-6.15-17.02-13.44-33.68-17.47-51.47l-8.52-104.4c4.04.26,12.16-1.74,13.73,3.28,2.71,35.37,8.48,70.41,12.25,105.65,1.34,12.57.81,27.05,2.02,38.95Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1829.05,2036.11c-6.47-46.97-10.35-94.51-12-141.88l10.87-.07c9.02,47.82,15.75,93.76,5.13,141.95h-4Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1641.15,1886.25c-.44-7.36-.46-9.2,6.9-10.09,36.02-4.33,92.78.18,129.95,2.18,4.77.26,28.07-1.12,29.08-.07.28.29.39,7.98,0,7.98h-165.91Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2081.92,1890.25c-3.24-.99-3.35-6.91-3.01-9.98,56.8-1.25,113.12,3.39,169.93,2-.27,1.42.39,7.98,0,7.98h-166.91Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2054.93,2034.12c-10.24-45.54.62-90.42,4.87-136l9.11-1.88c-3.17,43.07-4.89,86.93-9.99,129.89l-2,4c-.15,1.29.18,2.72,0,4h-2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1509.21,
    y: 1876.26,
    width: 41.98,
    height: 5.99
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2342.78,
    y: 1882.26,
    width: 41.98,
    height: 5.99
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2286.81,2038.11c.53,4.07,5.13,13.5-.98,12-2.02-.5-2.16-9.62-3.02-12h4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1833.05,2036.11c-.69,3.13-1.23,7.53-3,10.01-2.04-.02-.68-7.68-1-10.01h4Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1603.17,2042.11c-.97,2.29.68,7.32-3.98,7.99-1.54-3.16,1.9-6.88,1.98-7.99h2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2056.93,2034.12c-.06.41,4.75,3.66-1.98,5.99-.3-1.9.36-4.29-.02-5.99h2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2056.93,2030.12l2-4c-.42,3.52-1.97,3.77-2,4Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2286.81,2034.12l-2-4c.02.22,1.62.53,2,4Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Countertop",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Countertop",
    className: "cls-2",
    style: {
      opacity: 0
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2540.23,1487.04c1.16,2.01,1,21.34-.71,21.59l-1178.27-5.18c.96-7.48-2.61-17.13,2.96-22.9,66.48-43.24,128.91-93.32,195.53-136.24,7.4-4.77,13.46-10.84,22.3-11.67,23.79-2.24,48.47,1.95,71.99,2.22,226.96,2.61,455.19-4.04,681.47,2.18l204.73,150.01Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1165.38,1274.84c1.44,1.43-4.57,5.93,9.23,7.72,22.95,2.98,62.38,2.67,85.52.03,8.87-1.01,17.13-6.55,24.33-7.65,10.05-1.54,22.5.86,32.87-.13l-.21,11.8-830.84,283.45c-144.14,1.09-288.41.91-432.3-1.51.75-6.43-3.07-23.81,5.39-25.69,2.81-.63,7.88,1.78,13.03,1.3,14.38-1.34,53.66-18.01,64.18-15.61,1.49.34,1.2,3.61,2.73,3.98,21.65,5.23,68.11-16.2,92.1-19.43,42.89.31,82.4-20.07,124.33-26.58l1.36-16,283.85-71.86c3.7-.3,1.54,3.67,5.59,4.19,7.56.97,36.24.07,41.95-3.96,2.21-1.56.05-5.7,2.29-6.33,6.41-1.78,22.32.96,31.38-.35,2.25-.32,18.67-4.93,19.22-5.77,1.77-2.68-2.43-11.79,3.63-13.36,19.81-2.6,41.62-12.61,60.94-15.02,11.33-1.41,19.08,4.67,28.6-7.34,81.98-15.38,171.06-53.19,252.44-65.41,12.87-1.93,6.01,1.81,10.41,6.45,4.78,5.05,43.5,3.7,51.37,1.36,15.78-4.69,9-16.69,10.65-18.35.21-.21,5.76-.18,5.97.04ZM1069.44,1346.75h-162.92l-118.92,32c-.48,3.47,4.54,1.88,6.96,1.97,58.51,2.2,120.55-5.4,179.76-2.17l95.12-31.8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3368.25,1426.68c.85.85-.89,15.11.02,15.97,1.27,1.2,31.28,2.87,34.87,2.15,3.27-.65-4.29-7.66,9.92-5.91,13.61,1.68,4.4,13.06,7.18,15.75,1.19,1.15,30.95,4.41,32.93,4.12,6.44-.93,4.03-6.71,5.26-7.85,3.35-3.11,72.75,19.35,83.54,19.92,1.53,4.97-1.54,18.07.54,21.45,2.94,4.79,50.35,13.25,58.65,14.29,13.32,1.67,10.1-.07,21.45,4.6,12.94,5.33,36.33,8.5,50.51,9.39,6.28.4,31.72,1.33,35.87.15,2.62-.74-.25-6.01,2.11-6.16,32.17,6.83,64.11,20.42,96.93,22v26c-26.98-.44-54.06.52-81.06.08-118.2-1.89-237.06-1.63-355.24-4.57l-325.11-111.62-.2-19.78h321.83Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2805.54,1310.79c3.46,1.11,2.67,10.69,17.9,12.08,13.88,1.28,24.84,3.1,28.39-12.18,10.47,1.4,70.47-2.41,74.44,2.29,1.57,1.86-2.11,14.31,3.23,19.76,6.62,6.75,54.22,8.66,60.16,4.17,1.83-1.39,2.15-5.99,4.08-6.29,2.47-.39,46.86,10.43,48.48,12.33,1.24,1.44-.39,10.72.21,13.81-7.62,2.54-17.51-3.58-23.39-3.52-4.61.04-11.06,4.14-21.57,3.47-20.8-1.32-20.24-2.62-41.93.1-12.39,1.55-22.17-3.65-30.44-3.57-5.78.05-13.97,4.54-25.58,3.49-15.23-1.37-12.14-1.03-25.9.14-16.26,1.38-42.65-8.6-37.1,15.87l-134.67-47.75-1.24-14.2h104.95Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Wall_Cabinets",
    "data-name": "Wall Cabinets",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wall_Cabinets",
    className: "cls-2",
    style: {
      opacity: 0
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3802 714 3802 748 3479.66 804 3332 804 3332 776 3627.74 714.55 3802 714"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3804 434 3804 465 3478.52 573.52 3332 576 3332 548 3627.47 436.47 3804 434"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3048 694 3047.8 713.8 2918.98 754.38 2834.21 754.38 2834.21 735.49 2949 694 3048 694"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2833.02 881.87 2833.02 898.89 2921.87 901.96 3048.08 876.86 3048.01 857.99 2946.34 859.23 2833.02 881.87"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2907.49 1025.02 2907.49 1042.38 2923.95 1042.38 2923.95 1045.19 2833.19 1045.19 2833.19 1027.06 2907.49 1025.02"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1675.06 652.43 1673.58 695.53 1676.85 698.21 1676.85 704.34 1675.06 1098 2221.7 1098 2221.7 694.64 2224.64 694.64 2224.64 650.21 1675.06 652.43"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Base_Cabinets",
    "data-name": "Base Cabinets",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base_Cabinets",
    className: "cls-2",
    style: {
      opacity: 0
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1311.31,1288.81l1.14,251.89-24.27,3.71-804.01,570.03c-2.62,9.8,4.52,33.68-6.46,38.52l-411.75-2.94-6-579.48,422.32,1.52,829.03-283.24Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3804.03,1562.54l-4,577.49-420.29-4.5c-16.53-4.11-6.71-28.45-9.94-41.04l-276.97-200.66-1.42-35.56-38.68-27.28c1.7-22.82-3.35-51.71-.48-73.75.46-3.55,10.63-8.7,0-17.71v-221.99s6.18-7.91,6.18-7.91l-5.79-1.15c-4.1-9.45,4.91-9.9,5.81-14.79,1.23-6.6-1.51-41.45-.04-43.02l318.99,109.72,426.62,2.16Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2222.84 1228.86 2222.84 1334.76 1682.12 1334.76 1679.13 1331.77 1679.13 1228.86 2222.84 1228.86"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2706.59,1326.77l141.73,48.15c-.78,10.77,1.76,24.55.3,34.88-.65,4.58-6.4,11.29-3.57,14.51.89,1.01,4.45-1.1,3.49,3.36-7.65,2.14-2.82,12.14-4.01,19.01h-13.99c-3.25,9.37,11.28,7.93,12.08,11.29l-.19,221.59c-.26,10.41,27.46,21.25,28.24,27.81l-.15,23.05-17.91-1.1-130.85-97-15.16-4.82v-300.72Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Island_Cabinets",
    "data-name": "Island Cabinets",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Island_Cabinets",
    className: "cls-2",
    style: {
      opacity: 0
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1397.27,1530.58v-25.99c360.01,1.16,720.27,4.66,1080.52,3.92l24.91,2.07v23.99h-43.99l-4.17,489.55h-48.81c-2.36-3.99-14.99-22.41-14.99-24.98v-114.89l-883.54-7.99v112.9c0,2.57-12.63,20.99-14.99,24.98h-48.97l-2-483.55h-43.98Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Backsplash",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Backsplash",
    className: "cls-2",
    style: {
      opacity: 0
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2949,694c-4.22.66-22.05,10.87-24.99,8l3.96-131.03,874.09-449.91,13.93-3.05-20,1420-872.04-224.95.31-411.79,123.82-24.4-.07-18.87c-41.39.93-83.11-2.83-124.01,4.01v-110l123.8-38.2.2-19.8h-99ZM3804,434c-58.99-.62-117.73.3-176.53,2.47l-295.47,111.53v28c48.98.53,97.74-.13,146.52-2.48l320.62-105.38,4.86-3.14v-31ZM3802,714l-172.76.24-297.24,61.76v28l148.76-.24,321.24-55.76v-34ZM3800,994c-61.94-1.81-124.83-3.71-187.08-2.08-79.87,2.08-159.91,8.61-239.84,12.16-8.7.39-36.72-1.96-41.92,1.69-2.99,2.1-.23,21.15-1.17,26.24l470.01-6.01v-32Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1316,1188v90h-191L66.9,1546.07c-3.4.12-7.34.53-8.62-3.36-.7-2.11-2.13-23.04-2.36-27.64-2.89-56.73,2.24-116.01.19-172.98l1064.92-154.07,194.97-.03Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1694,
    y: 1098,
    width: 516,
    height: 114
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Tall_Cabinets",
    "data-name": "Layer 7",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tall_Cabinets",
    className: "cls-2",
    style: {
      opacity: 0
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2926.48,571.47v128.88l-90.72,34.76-1.24,18.19h85.96v104.9l-86.79,22.75c-2.47,1.69-2.26,16.15,1.84,18.21h84.96v127.88h-87.95v16s87.95,1.99,87.95,1.99v267.75h-221.88c-4.65,10,6,14.08,6,14.99v298.72h-2v-41.96l-86.99-57.92c-4.07-.52-2.6.16-2.97,2.94-.47,3.55.69,18.36.01,19.03h-12.02c1.02-222.12-1.28-444.34-.08-666.49.31-56.94,9.16-137.25,2.25-191.86-.48-3.82-3.83-1.9-4.31-5.73-1.54-12.19,1.57-27.53,0-40.16l107.1-72.87h220.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntitled);
export default __webpack_public_path__ + "static/media/Untitled.1244efd8d287260f0fcac3d2eecd41b0.svg";
export { ForwardRef as ReactComponent };